import React from 'react'

const Pandas = () => {
    return (
        <div className='container'>
            <h1>Pandas</h1>
            <p>Pandas is an open-source Python Library providing high-performance data manipulation and analysis tool using its powerful data structures. The name Pandas is derived from the word Panel Data – an Econometrics from Multidimensional data.
<br /> <br />
In 2008, developer Wes McKinney started developing pandas when in need of high performance, flexible tool for analysis of data.
<br /> <br />
Prior to Pandas, Python was majorly used for data munging and preparation. It had very little contribution towards data analysis. Pandas solved this problem. Using Pandas, we can accomplish five typical steps in the processing and analysis of data, regardless of the origin of data — load, prepare, manipulate, model, and analyze.
<br /> <br />
Python with Pandas is used in a wide range of fields including academic and commercial domains including finance, economics, Statistics, analytics, etc.</p>
 <br /> <br />
 <h3>Key Features of Pandas</h3>
 <ul>
     <li>Fast and efficient DataFrame object with default and customized indexing.</li>
     <li>Tools for loading data into in-memory data objects from different file formats.</li>
     <li>Data alignment and integrated handling of missing data.</li>
     <li>Reshaping and pivoting of date sets.</li>
     <li>Label-based slicing, indexing and subsetting of large data sets.</li>
     <li>Columns from a data structure can be deleted or inserted.</li>
     <li>Group by data for aggregation and transformations.</li>
     <li>High performance merging and joining of data.</li>
     <li>Time Series functionality.</li>
 </ul>
 <h1>Introduction to Data Structures</h1>
 <p><strong>Pandas deals with the following three data structures −</strong></p>
 <ol>
     <li>Series</li>
     <li>Data frame</li>
     <li>Panel</li>
 </ol>
 <p>These data structures are built on top of Numpy array, which means they are fast.</p>
 <h3>Dimension & Description</h3>
 <p>The best way to think of these data structures is that the higher dimensional data 
     structure is a container of its lower dimensional data structure.  <br />
     For example, DataFrame is a container of Series, Panel is a container of DataFrame.</p> <br />
     <table class="table table-bordered">
<tbody><tr>
<th style={{textAlign:'center'}}>Data Structure</th>
<th style={{textAlign:'center'}}>Dimensions</th>
<th style={{textAlign:'center'}}>Description</th>
</tr>
<tr>
<td style={{textAlign:'center'}}>Series</td>
<td style={{textAlign:'center'}}>1</td>
<td style={{textAlign:'center'}}>1D labeled homogeneous array, sizeimmutable.</td>
</tr>
<tr>
<td style={{textAlign:'center'}}>Data Frames</td>
<td style={{textAlign:'center'}}>2</td>
<td style={{textAlign:'center'}}>General 2D labeled, size-mutable tabular structure with potentially heterogeneously typed
columns.</td>
</tr>
<tr>
<td style={{textAlign:'center'}}>Panel</td>
<td style={{textAlign:'center'}}>3</td>
<td style={{textAlign:'center'}}>General 3D labeled, size-mutable array.</td>
</tr>
</tbody></table>
Building and handling two or more dimensional arrays is a tedious task, burden is placed 
on the user to consider the orientation of the data set when writing functions. But 
using Pandas data structures, the mental effort of the user is reduced. <br />
For example, with tabular data (DataFrame) it is more semantically helpful to think of the <strong>index</strong>  (the rows) and the <strong>columns </strong> rather than axis  0 and axis 1.
      <h3>Mutability</h3>
      <p>All Pandas data structures are value mutable (can be changed) and except Series all are size mutable. Series is size immutable.
<br /> <br />
<strong>Note</strong>  − DataFrame is widely used and one of the most important data structures. Panel is used much less.</p>
        <h3>Series</h3>
        <p>Series is a one-dimensional array like structure with homogeneous data.</p>
    <h3>Key Points</h3>
    <ul>
        <li>Homogeneous Data</li>
        <li>Size Immutable</li>
        <li>Values of Data Mutable</li>
    </ul>
    <h3>DataFrame</h3>
    <p>DataFrame is a two-dimensional array with heterogeneous data. For example,</p>
    <table class="table table-bordered">
    <tbody><tr>
<th style={{textAlign:'center'}}>Name</th>
<th style={{textAlign:'center'}}>Age</th>
<th style={{textAlign:'center'}}>Gender</th>
<th style={{textAlign:'center'}}>Rating</th>
</tr>
<tr>
<td style={{textAlign:'center'}}>Steve</td>
<td style={{textAlign:'center'}}>32</td>
<td style={{textAlign:'center'}}>Male</td>
<td style={{textAlign:'center'}}>3.45</td>
</tr>
<tr>
<td style={{textAlign:'center'}}>Lia</td>
<td style={{textAlign:'center'}}>28</td>
<td style={{textAlign:'center'}}>Female</td>
<td style={{textAlign:'center'}}>4.6</td>
</tr>
<tr>
<td style={{textAlign:'center'}}>Vin</td>
<td style={{textAlign:'center'}}>45</td>
<td style={{textAlign:'center'}}>Male</td>
<td style={{textAlign:'center'}}>3.9</td>
</tr>
<tr>
<td style={{textAlign:'center'}}>Katie</td>
<td style={{textAlign:'center'}}>38</td>
<td style={{textAlign:'center'}}>Female</td>
<td style={{textAlign:'center'}}>2.78</td>
</tr>
</tbody> </table>
<p>The table represents the data of a sales team of an organization with their overall 
    performance rating. The data is represented in rows and columns. Each column 
    represents an attribute and each row represents a person.</p>
    <h3>Data Type of Columns</h3>
    The data types of the four columns are as follows − <br />
    <table class="table table-bordered">
    <tbody><tr>
<th style={{textAlign:'center'}}>Column</th>
<th style={{textAlign:'center'}}>Type</th>
</tr>
<tr>
<td style={{textAlign:'center'}}>Name
</td><td style={{textAlign:'center'}}>String
</td></tr>
<tr>
<td style={{textAlign:'center'}}>Age
</td><td style={{textAlign:'center'}}>Integer
</td></tr>
<tr>
<td style={{textAlign:'center'}}>Gender
</td><td style={{textAlign:'center'}}>String
</td></tr>
<tr>
<td style={{textAlign:'center'}}>Rating
</td><td style={{textAlign:'center'}}>Float
</td></tr>
</tbody> </table>
<ul>
        <li>Homogeneous Data</li>
        <li>Size Mutable</li>
        <li>Data Mutable</li>
    </ul>
    <h3>Panel</h3>
    <p>Panel is a three-dimensional data structure with heterogeneous data. It is hard 
        to represent the panel in graphical representation. But a panel can be illustrated
         as a container of DataFrame.</p>
         <ul>
        <li>Homogeneous Data</li>
        <li>Size Mutable</li>
        <li>Data Mutable</li>
    </ul>
        </div>
    )
}

export default Pandas
